

export default function (state = {}, action) {
    switch (action.type) {
        case 'Water_Store':
            return { ...state, water_org: action.payload.org, water_device: action.payload.device, water_value: action.payload.value, water_valueDate: action.payload.valueDate }
        default:
            return state;
    }
}